module.exports = __webpack_public_path__ + "static/media/gr.ecc1fb23.svg";